module.exports = __webpack_public_path__ + "static/media/logo140.ae51f70b.png";